import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

import { autoSyncWebPushSubscription } from './services/webPushService';

// Registra o Service Worker do PWA para funcionalidade offline e notificações push em segundo plano
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    registerSW({
      immediate: true,
      onRegisteredSW() {
        // Se a permissão já foi concedida anteriormente, sincroniza a inscrição em background
        autoSyncWebPushSubscription().catch(() => {});
      },
      onRegisterError() {
        // Fallback para registro direto
        navigator.serviceWorker.register('/sw.js', { scope: '/' })
          .then(() => autoSyncWebPushSubscription())
          .catch(() => {});
      }
    });
  } catch {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(() => autoSyncWebPushSubscription())
      .catch(() => {});
  }
}


const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
